import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'perjalananDinas'

const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterRegion = 'Master/Region/list/'
export const masterSignatories = 'Master/List/signatories/'

export const perjalananDinasList = 'Kepegawaian/perjalananDinas/list/'
export const perjalananDinasListIzin = 'Kepegawaian/perjalananDinas/listIzin/'
export const perjalananDinasInactive = 'Kepegawaian/perjalananDinas/inactive/'
export const perjalananDinasCreate = 'Kepegawaian/perjalananDinas/create/'
export const perjalananDinasUpdate = 'Kepegawaian/perjalananDinas/update/'
export const perjalananDinasDetail = 'Kepegawaian/perjalananDinas/detail/'
export const perjalananDinasApproval = 'Kepegawaian/perjalananDinas/approval/'

export const partisipanList = 'Kepegawaian/perjalananDinas/partisipan/'
export const EmployeeDetail = 'Kepegawaian/perjalananDinas/employee/'
export const perjalananDinasDetailCancel = 'Kepegawaian/perjalananDinas/detailCancel/'
export const uploadpresensi = 'Kepegawaian/perjalananDinas/uploadpresensi/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}